import React, { useState, useEffect } from 'react';
import { Eye, LogOut, Loader2 } from 'lucide-react';
import axios from 'axios';
import { BACKEND_URL } from '../config/api';

// Amber bar shown while an admin is viewing the app as a user (support mode)
export const ImpersonationBanner = () => {
  const [status, setStatus] = useState(null);
  const [exiting, setExiting] = useState(false);
  const isAdminRoute = window.location.pathname.startsWith('/ti-admin');

  useEffect(() => {
    if (isAdminRoute) return;
    axios.get(`${BACKEND_URL}/api/user/impersonation-status`, { withCredentials: true })
      .then((res) => { if (res.data.active) setStatus(res.data); })
      .catch(() => {});
  }, [isAdminRoute]);

  if (!status?.active || isAdminRoute) return null;

  const exit = async () => {
    setExiting(true);
    try {
      await axios.post(`${BACKEND_URL}/api/ti-admin/impersonation/stop`, {}, { withCredentials: true });
      window.location.href = '/ti-admin/users';
    } catch {
      setExiting(false);
    }
  };

  const minsLeft = status.expires_at ? Math.max(0, Math.round((new Date(status.expires_at) - Date.now()) / 60000)) : null;

  return (
    <div data-testid="impersonation-banner" style={{ position: 'sticky', top: 0, zIndex: 100000, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, flexWrap: 'wrap', background: '#fbbf24', color: '#451a03', padding: '8px 14px', fontSize: 13, fontWeight: 600, boxShadow: '0 1px 4px rgba(0,0,0,0.15)' }}>
      <Eye size={15} />
      <span>
        Support view: acting as <strong>{status.user?.name || status.user?.email}</strong>
        {minsLeft !== null && ` · expires in ${minsLeft} min`} · sensitive actions disabled
      </span>
      <button onClick={exit} disabled={exiting} data-testid="exit-impersonation-btn"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#451a03', color: '#fde68a', border: 'none', borderRadius: 999, padding: '5px 14px', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>
        {exiting ? <Loader2 size={13} className="spin" /> : <LogOut size={13} />} Exit support view
      </button>
    </div>
  );
};

export default ImpersonationBanner;
